import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Field, useField } from 'react-final-form';

import { TagChip } from 'components/ui';
import { Autocomplete as MuiAutocomplete } from '@mui/lab';
import { TextField as MuiTextField, Box as MuiBox } from '@mui/material';
import { KeyboardArrowDown as KeyboardArrowDownIcon } from '@mui/icons-material';
import ListBox from 'components/ListBox';
import { useTranslation } from 'react-i18next';

const FormSelectOutsideTag = ({
  name,
  options,
  placeholder,
  getTag = (item) => item,
  getOptionLabel = (option) => option.title,
  isOptionEqualToValue = (option, value) => option === value,
  boxStyle = {},
  onScroll = () => {},
  inputOnChange,
  loading,
  unique,
  wrapperStyle = { marginTop: 15 },
  inputStyle = {},
  renderOption,
  'data-testid': dataTestId,
  ...restProps
}) => {
  const { t } = useTranslation();
  const infiniteScroll = (e) => {
    const scrollTop = e.target.scrollTop;
    const scrollHeight = e.target.scrollHeight;
    const clientHeight = e.target.clientHeight;

    if (scrollTop + clientHeight >= scrollHeight - 1) {
      onScroll();
    }
  };

  const field = useField(name);

  const [currentOptions, setCurrentOptions] = useState(field.input.value || []);

  // need to refactor this component, get rid of incoherence in format like value/value.value/value.title etc
  const handleDelete = (value) => {
    setCurrentOptions(
      currentOptions.filter((opt) => {
        if (typeof opt === 'string') {
          return getTag(opt) !== value;
        } else {
          return getTag(opt).value !== value.value;
        }
      })
    );
    field.input.onChange(
      currentOptions.filter((opt) => {
        if (typeof opt === 'string') {
          return getTag(opt) !== value;
        } else {
          return getTag(opt).value !== value.value;
        }
      })
    );
  };

  const addUnique = (value) => {
    let unique = [];
    for (let i = 0; i < value.length; i++) {
      if (value?.id || value?.[0]?.id) {
        if (!unique.find((item) => item.id === value[i].id)) {
          unique.push(value[i]);
        }
      } else {
        if (!unique.find((item) => item.value === value[i].value)) {
          unique.push(value[i]);
        }
      }
    }
    return unique;
  };

  return (
    <Field name={name}>
      {({ input, meta }) => (
        <MuiBox style={boxStyle}>
          <SMuiAutocomplete
            multiple
            id="tags-outlined"
            variant="outlined"
            options={options}
            noOptionsText={t('No options')}
            getOptionLabel={getOptionLabel}
            isOptionEqualToValue={isOptionEqualToValue}
            // defaultValue={currentOptions}
            loading={loading}
            onBlur={() => inputOnChange && inputOnChange('')}
            value={currentOptions}
            ListboxComponent={ListBox}
            onChange={(event, value) => {
              if (unique) {
                setCurrentOptions(addUnique(value));
                input.onChange(addUnique(value));
              } else {
                setCurrentOptions(value);
                input.onChange(value);
              }
              inputOnChange && inputOnChange('');
            }}
            ListboxProps={{ onScroll: (e) => infiniteScroll(e) }}
            renderTags={() => {}}
            popupIcon={restProps.disabled ? null : <KeyboardArrowDownIcon />}
            renderInput={(params) => (
              <MuiTextField
                {...params}
                variant="outlined"
                onChange={(e) => inputOnChange && inputOnChange(e.target.value)}
                onKeyDown={(event) => {
                  if (event.key === 'Backspace' || event.key === 'Delete') {
                    event.stopPropagation();
                  }
                }}
                placeholder={placeholder}
                inputProps={{
                  ...params.inputProps,
                  'data-testid': dataTestId
                }}
              />
            )}
            renderOption={renderOption}
          />
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
            }}
          >
            {currentOptions?.map?.((tag, index) => {
              return (
                <TagChip
                  key={index}
                  isCanDelete={true}
                  handleDelete={handleDelete}
                  tag={getTag(tag)}
                />
              );
            })}
          </div>
        </MuiBox>
      )}
    </Field>
  );
};

const SMuiAutocomplete = styled(MuiAutocomplete)`
  width: 100%;
  height: 45px;
  .MuiOutlinedInput-root {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    width: 100%;
    fieldset {
      top: 0;
    }
    legend {
      display: none;
    }
  }
`;

export default FormSelectOutsideTag;
